import React, { useEffect, useState, useContext } from 'react';
import Quotes from '../components/Quotes';
import Petro from '../components/Petro';
import TimeZones from '../components/TimeZones';
import Links from '../components/Links';
import Stories from '../components/Stories';
import Header from '../components/Header';
import Tickers from '../components/Tickers';
import ApplicationContext from '../components/ApplicationContext';
import {deepEqual, getDataWithFetch, setLocalStorage} from "../components/Utils";
import "../assets/css/app.css";
import "../assets/css/likedislike.css";
import "../assets/css/topStories.css";
import "../assets/css/timezone.css";
import "../assets/css/filter.css";
import "../assets/css/checkbox.css";
import "../assets/css/quotes.css";
import "../assets/css/regions.css";
import "../assets/css/dropdown.css";
import "../assets/css/header.css";
import "../assets/css/translation.css";
import "../assets/css/carousel.css";

const HomePage = ({ setData }) => {
	const data = useContext(ApplicationContext);
	const [topStoriesResults, setTopStoriesResults] = useState();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		// console.log('DEBUG', `HomePage - data.BASE_URL = `, data.BASE_URL);
		// console.log('DEBUG', `HomePage - data.TopStoriesResults = `, data.TopStoriesResults);

		(async() => {
			if (data.BASE_URL) {
				// console.log('DEBUG:  BASE_URL - ', data.BASE_URL);
				const url = data.BASE_URL + "index.php/news_data/get_top_stories";
				const res = await getDataWithFetch(url);
				setTopStoriesResults(res);
				// console.log('DEBUG', `Stories - get_top_stories number of records ${res ? res.length : 0}`);
				if (!deepEqual(data.TopStoriesResults, res)) {
					data.TopStoriesResults = res;
				}
			}
		})()
		// console.log('DEBUG', `HomePage - data.enableAdmin = ${data.enableAdmin}`);
	}, [data, data.BASE_URL, data.TopStoriesResults]);

	const handleLanguageChange = (newLanguage) => {
		// console.log('DEBUG', `HomePage:  new language selection is ${newLanguage}`);
		data.lang = newLanguage;
	};

	return (
		<>
			{/* {(() => {
				console.log('DEBUG:  admin NOT enabled')
			})()} */}
			<Header onLanguageChange={handleLanguageChange} />
			<TimeZones />
			<Tickers />
			<Quotes />
			<Petro />
			<Links />
			<div className="all-links-container">
				{
					(topStoriesResults?.length > 0) && 
					<h3 className="all-links"><button className="link-button" onClick={(e) => {
						e.preventDefault();
						setLocalStorage('currentPage', 'topstories');
						data.currentPage = 'topstories';
						setData((prev) => ({ ...prev, currentPage: 'topstories' }))
					}}>Top Stories</button></h3>
				}

				<h3 className="all-links hide"><button className="link-button" onClick={(e) => {
						e.preventDefault();
						setLocalStorage('currentPage', 'faq');
						data.currentPage = 'faq';
						setData((prev) => ({ ...prev, currentPage: 'faq' }))
					}}>How Data is Aggregated on this site</button></h3>
				<h3 className="all-links hide"><button className="link-button" onClick={(e) => {
					e.preventDefault();
					setLocalStorage('currentPage', 'invest');
					data.currentPage = 'invest';
					setData((prev) => ({ ...prev, currentPage: 'invest' }))
				}}
				>Investor Relations</button></h3>
			</div>
			<Stories enableAdmin={false} topStories={false} />
		</>
	);
}

export default HomePage;
